import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface RestoreMatrixSnapshotModalProps {
    savedAt: string | null;
    isRestoring: boolean;
    onDismiss: () => void;
    onConfirmRestore: () => void;
}

export const RestoreMatrixSnapshotModal = ({
    savedAt,
    isRestoring,
    onDismiss,
    onConfirmRestore,
}: RestoreMatrixSnapshotModalProps) => {
    const visible = Boolean(savedAt);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, savedAt]);

    const when = savedAt
        ? new Date(savedAt).toLocaleString(undefined, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
          })
        : '';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Put this matrix back?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonOnClick={onDismiss}
                        buttonDisabled={isRestoring}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isRestoring ? 'Putting back...' : 'Put back'}
                        buttonOnClick={onConfirmRestore}
                        buttonDisabled={isRestoring || !confirmReady}
                    />
                </div>
            }
        >
            <p>
                This puts the matrix back to the save from {when}. Levels and rows added after that save come off
                this unit. The parts and procedures stay in Resources.
            </p>
        </CustomModal>
    );
};
